import AIcon from './index.vue';

AIcon.install = app => {
  app.component(AIcon.name, AIcon);
};

export default AIcon;
